// 계정·서버 저장 진입점(D5a). main.ts는 두 줄만 부른다:
//   1) applyStagedRestore() — createGame 전(저장 모듈이 키를 읽기 전)에 당겨온 서버 진행을 적용
//   2) startAccount(hooks) — 부팅 뒤 세션 확인·주기 동기화 시작(게임 루프 밖)
// 설정 창(ui/screens.ts)은 mountAccountSection으로 계정 묶음을 붙인다.
import { AccountClient, type AccountHooks } from './client';
import { applyStagedRestore as applyStaged, type ApplyResult } from './sync';
import { mountAccountSection as mountSection, showRestoredToast, type AccountSection } from './panel';

let client: AccountClient | null = null;
export function accountClient(): AccountClient {
  client ??= new AccountClient();
  return client;
}

/** 부팅 맨 처음: 대기 중인 서버 스냅샷 적용(없으면 아무것도 안 함). 어떤 실패도 던지지 않는다 */
export function applyStagedRestore(): ApplyResult {
  try { return applyStaged(window.localStorage); }
  catch { return { applied: false, reason: 'unavailable' }; }
}

/** 부팅 뒤: 세션 확인·동기화 시작. 직전 부팅에서 서버 진행을 불러왔으면 가장자리 알림을 한 번 보인다 */
export function startAccount(hooks: AccountHooks): AccountClient {
  const c = accountClient();
  try {
    if (c.takeRestoredNotice()) showRestoredToast(document.body);
    c.start(hooks);
  } catch { /* 계정 기능 실패는 게임을 막지 않는다 */ }
  return c;
}

/** 설정 창에 계정 묶음을 붙인다(창을 열 때 refresh로 시각 문구를 갱신) */
export type { AccountSection };
export function mountAccountSection(parent: HTMLElement): AccountSection {
  return mountSection(parent, accountClient());
}
